import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCountryPricingRuleQuery } from 'api';

export const usePricing = () => {
  const [updateModalState, setUpdateModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data = {} } = useCountryPricingRuleQuery({ countryId: id });
  const onUpdateModalStateChange = useCallback(() => setUpdateModalState((prevState) => !prevState), []);
  return {
    updateModalState,
    onUpdateModalStateChange,
    dataToEdit: data?.countryPricingRules || {},
  };
};
